import React from 'react'
import { Link } from 'react-router-dom';

// import "../../assets/js/utilty/home_page_header.js"
import "../../assets/css/utility/home_page_header.css";
import PDLogo from "../../assets/media/logo/pd_logo_(white).png";
import MenuBar from './MenuBar'

const NonLoggedInUserHeader = () => {
  return (
    <header className="user-header">
        <div className="container">
            <div className="header-navigations">
                <Link to="/">
                    <div id="logo">
                        <img src={PDLogo} alt="" />
                    </div>
                </Link>

                <div className="nav-bar">
                    <Link to="/">Home</Link>
                    <a href="#">Load Feed</a>
                    <a href="#">Order</a>
                </div>


                <MenuBar/>
            </div>
        </div>
    </header>
  )
}

export default NonLoggedInUserHeader